import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { EventResponse } from 'src/app/models/core/event.model';
import { ListingRole } from 'src/app/types/event-access.types';

@Injectable({
  providedIn: 'root'
})
export class SmEventApiService {
  private baseUrl = `${environment.api_server}/api`;

  constructor(
    private _http: HttpClient,
    private _api: ApiService,
  ) { }

  /**
   * Params de un request a `/sales-manager/events*`. El back (`validateRequestedRole`)
   * usa `role` para acotar el scope (jefe de ventas ve solo los eventos de sus locales,
   * no toda la productora). El rol es obligatorio y solo puede ser
   * `administrator`/`sales-manager`: cualquier otro (`global-report`, `seller`, ...)
   * haría que el back devuelva 422.
   */
  private buildParams(
    role: ListingRole,
    page: number,
    limit: number,
    query?: string,
  ): HttpParams {
    let params = new HttpParams()
      .set('page', String(page))
      .set('per_page', String(limit))
      .set('role', role);

    if (query) params = params.set('q', query);

    return params;
  }

  public getUpcomingEvents(
    page: number,
    limit: number,
    query: string | undefined,
    role: ListingRole,
  ): Observable<EventResponse> {
    const url = `${this.baseUrl}/sales-manager/events`;
    const params = this.buildParams(role, page, limit, query);
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<EventResponse>(url, { headers, params })
      )
    );
  }

  public getPastEvents(
    page: number,
    limit: number,
    query: string | undefined,
    role: ListingRole,
  ): Observable<EventResponse> {
    const url = `${this.baseUrl}/sales-manager/events/past`;
    const params = this.buildParams(role, page, limit, query);
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<EventResponse>(url, { headers, params })
      )
    );
  }

  public getInactiveEvents(
    page: number,
    limit: number,
    query: string | undefined,
    role: ListingRole,
  ): Observable<EventResponse> {
    const url = `${this.baseUrl}/sales-manager/events/inactive`;
    const params = this.buildParams(role, page, limit, query);
    return from(this._api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this._http.get<EventResponse>(url, { headers, params })
      )
    );
  }
}
